import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import {setAuthorisedUser, setIsAuthorised,setUserName, setCurrentRole} from "./store/reducers/AppReducer";
import { getStoredIdToken, getTokenExpiryFromJwt } from "./lib/tokenUtils";
import { firebaseSignOut, getFreshIdToken, runSsoExchangeOnce } from "./lib/firebaseAuth";
import { auth } from "./lib/firebase";
import axiosInstance from "./Fbaseurl";
import { normalizeRoleForRouting } from "./CommonUtils/roles";

const completeSsoSignIn = async (email) => {
  const response = await axiosInstance.get(`/users/${email}`);
  if (response.status !== 200) return false;

  const userName = `${response.data.firstName} ${response?.data?.lastName}`;
  localStorage.setItem("userName", userName);
  localStorage.setItem("userId", response.data.userName);
  localStorage.setItem("companyAssigned", response.data.companyId);
  localStorage.setItem("user", JSON.stringify(response.data));

  const roleResponse = await axiosInstance.get(`/users/currentRole`);
  const apiRole = (roleResponse?.data || "").toString().trim();
  const fallbackRole = Array.isArray(response.data?.roles)
    ? response.data.roles[0]
    : "";
  const resolvedRole = apiRole && apiRole !== "None" ? apiRole : fallbackRole;
  if (resolvedRole) {
    localStorage.setItem("currentRole", normalizeRoleForRouting(resolvedRole));
  }
  return true;
};

const ProtectedRoute = ({ element: Element, allowedRoles }) => {
  //   const user = useSelector((state) => state.app.authorisedUser);
  //   const isAuthorised = useSelector((state) => state.app.isAuthorised);
  //   const role = user?.roles[0] || "";
  const dispatch = useDispatch();
  const [sharedTokenValid, setSharedTokenValid] = useState(true);
  const [ssoChecked, setSsoChecked] = useState(false);
  const signoutInProgress = useRef(false);
  const authExpired =
    typeof window !== "undefined" &&
    sessionStorage.getItem("authExpired") === "1";

  useEffect(() => {
    if (auth.currentUser || localStorage.getItem("user")) {
      setSsoChecked(true);
      return;
    }
    let cancelled = false;
    runSsoExchangeOnce()
      .then(async (user) => {
        if (user?.email) {
          await completeSsoSignIn(user.email).catch(() => {});
        }
        return user;
      })
      .catch(() => null)
      .finally(() => {
        if (!cancelled) setSsoChecked(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!ssoChecked) return;

    const checkSharedLogout = async () => {
      if (authExpired) {
        setSharedTokenValid(false);
        return;
      }
      const token = getStoredIdToken();
      const expiry = getTokenExpiryFromJwt(token);
      const validToken = Boolean(token && (!expiry || expiry > Date.now()));
      if (validToken) {
        setSharedTokenValid(true);
        return;
      }
      const refreshed = await getFreshIdToken(true).catch(() => null);
      if (refreshed) {
        setSharedTokenValid(true);
        return;
      }
      try {
        sessionStorage.setItem("authExpired", "1");
      } catch {
        // ignore storage errors
      }
      setSharedTokenValid(false);
      if (!signoutInProgress.current) {
        signoutInProgress.current = true;
        firebaseSignOut()
          .catch(() => {})
          .finally(() => {
            signoutInProgress.current = false;
          });
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkSharedLogout();
      }
    };

    checkSharedLogout();
    window.addEventListener("focus", checkSharedLogout);
    document.addEventListener("visibilitychange", onVisibilityChange);
    const intervalId = window.setInterval(checkSharedLogout, 30000);

    return () => {
      window.removeEventListener("focus", checkSharedLogout);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.clearInterval(intervalId);
    };
  }, [ssoChecked]);

  if (!ssoChecked) {
    return <>...Loading</>;
  }

  const currentRole = localStorage.getItem("currentRole")
  const data = localStorage.getItem("user");
  const user = JSON.parse(data);
  let role;
  let isAuthorised = false;
  let name = localStorage.getItem("userName");
  if(name) {

      dispatch(setUserName(name));
  }
  if (user) {
      dispatch(setIsAuthorised(true));
      dispatch(setAuthorisedUser(user));
      dispatch(setCurrentRole(currentRole))
    isAuthorised = true;
    role = user?.roles[0] || "";
  }

  if (!sharedTokenValid) {
    return <Navigate to="/" />;
  }

  if (!isAuthorised) {
    return <Navigate to="/" />;
  }

  if (!allowedRoles.includes(currentRole)) {
    return <Navigate to="/" />;
  }

  return (
    <React.Suspense fallback={<>...Loading</>}>
      <Element />
    </React.Suspense>
  );
};

export default ProtectedRoute;
